import { useDraft } from '@cascade/react/hooks';
import { useI18n } from '@cascade/react/i18n';
import { useProjects } from '@cascade/react/projects';
import { Button, Select } from '@cascade/ui-library';
import classes from './ProjectPicker.module.scss';

export const ProjectPicker = () => {
  const { translate } = useI18n();
  const { projects, currentProjectId, selectProject } = useProjects();

  const {
    draft: selectedProjectId,
    isDirty,
    setDraft: setSelectedProjectId,
  } = useDraft(currentProjectId);

  const options = projects.map((project) => ({
    label: project.name,
    value: project.id,
  }));

  const canConfirm = isDirty && selectedProjectId !== undefined;

  const confirm = () => {
    if (!selectedProjectId) {
      return;
    }

    selectProject(selectedProjectId);
  };

  return (
    <div className={classes['project-picker']}>
      <Select
        label={translate('projects.picker.label')}
        placeholder={translate('projects.picker.placeholder')}
        options={options}
        value={selectedProjectId ?? ''}
        onChange={setSelectedProjectId}
        required
      />
      <Button
        label={translate('projects.picker.confirm')}
        disabled={!canConfirm}
        onClick={confirm}
      />
    </div>
  );
};
